import React from "react";
import { imageCodes, titleCodes, textCodes } from "../../template_codes/sarphosaung/home_page_codes";

function Home() {
    return (
        <div>
            {/*                   slider                   */}
            <div class="w-full bg-cover pt-10 style={{ backgroundImage: `url('${imageCodes.homeSlider.image}')` }}">
                <div className="py-10 md:py-24 lg:py-32 xl:py-52 text-center">
                    <a href="https://sarphosaung.com/" className="btn btn-xs lg:btn-sm xl:btn-lg btn-outline lowercase">{textCodes.shopNow.text}</a>
                </div>
            </div>
            {/*              end of slider                 */}

            {/*              category section                */}

            <div className="container w-full pt-10">
                <h1 className="text-center text-xl lg:text-2xl xl:text-2xl font-semibold lg:px-24 xl:px-24 px-4">{titleCodes.category.title}</h1>
                <p className="text-center pt-4 lg:px-24 xl:px-24 px-4">{textCodes.broughtText.text}</p>
                <div className="grid grid-cols-2 lg:grid-cols-6 xl:grid-cols-6 pt-8 lg:px-24 xl:px-24 px-4">
                    <div className="border">
                        <a href="https://sarphosaung.com/">
                        <img src={imageCodes.cate1.image} alt="rice" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.cat1Text.text}</p>
                        </a>
                    </div>
                    <div className="border">
                        <a href="https://sarphosaung.com/">
                        <img src={imageCodes.cate2.image} alt="rice" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.cat2Text.text}</p>
                        </a>
                    </div>
                    <div className="border">
                        <a href="https://sarphosaung.com/">
                        <img src={imageCodes.cate3.image} alt="rice" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.cat3Text.text}</p>
                        </a>
                    </div>
                    <div className="border">
                        <a href="https://sarphosaung.com/">
                        <img src={imageCodes.cate4.image} alt="rice" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.cat4Text.text}</p>
                        </a>
                    </div>
                    <div className="border">
                        <a href="https://sarphosaung.com/">
                        <img src={imageCodes.cate5.image} alt="rice" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.cat5Text.text}</p>
                        </a>
                    </div>
                    <div className="border">
                        <a href="https://sarphosaung.com/">
                        <img src={imageCodes.cate6.image} alt="rice" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.cat6Text.text}</p>
                        </a>
                    </div>
                </div>
            </div>
            {/*              end of category section                */}



            {/*                point banner                         */}
            
            <div className="container w-fit grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 px-4 pt-16 gap-1">
                <div className="border-2 border-[#71e0d9] text-center px-20 pt-10 xl:ml-10 lg:ml-10">
                    <p className="text-xl lg:text-2xl xl:text-2xl pb-4 xl:py-10">✔️ ဖုန်းထဲကနေ စျေးဝယ်ပါ</p>
                    <p className="text-xl lg:text-2xl xl:text-2xl pb-4 xl:pb-10">✔️ ပွိုင့်စုပါ</p>
                    <p className="text-xl lg:text-2xl xl:text-2xl pb-4 xl:pb-20">✔️ လက်ဆောင်ယူပါ</p>
                    <p className="btn btn-sm lg:btn-md xl:btn-lg bg-[#71e0d9] border-0 text-[#000000] hover:bg-[#ffdf5a] mb-8">download app</p>
                </div>
                <div>
                    <img src={imageCodes.promoBanner.image}></img>
                </div>
            </div>
            
            {/* 
            <div className="xl:pr-36 lg:pl-20 pr-8">
                <div class="mt-14 bg-sarphosaung_pointSlider bg-no-repeat bg-contain">
                    <div className="lg:py-10 xl:py-40 py-20 lg:pl-4 xl:pl-28">
                        <a href="https://play.google.com/store/apps/details?id=com.piti.member" className="btn btn-xs lg:btn-md xl:btn-md btn-outline lowercase ml-14 lg:ml-32 xl:ml-56 lg:mt-28 xl:mt-28">{textCodes.downloadApp.text}</a>
                    </div>
                </div>
            </div>*/}
            {/*                end of point banner                   */}


            {/*              local product section                */}

            <div className="container w-full pt-10">
                <h1 className="text-center text-xl lg:text-2xl xl:text-2xl font-semibold lg:px-24 xl:px-24 px-4">{titleCodes.category.title}</h1>
                <p className="text-center pt-4 lg:px-24 xl:px-24 px-4">{textCodes.broughtText.text}</p>
                <div className="grid grid-cols-2 lg:grid-cols-6 xl:grid-cols-6 pt-8 lg:px-24 xl:px-24 px-4">
                    <div className="border bg-[#f2f2f2]">
                    <img src={imageCodes.localRice.image} alt="Local Product" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.tea3Text.text}</p>
                    </div>
                    <div className="border bg-[#f2f2f2]">
                        <img src={imageCodes.localEgg.image} alt="Local Product" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.tea2Text.text}</p>
                    </div>
                    <div className="border bg-[#f2f2f2]">
                        <img src={imageCodes.localBeann.image} alt="Local Product" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.oilText.text}</p>
                    </div>
                    <div className="border bg-[#f2f2f2]">
                        <img src={imageCodes.localBagyi.image} alt="Local Product" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.bagyiText.text}</p>
                    </div>
                    <div className="border bg-[#f2f2f2]">
                        <img src={imageCodes.localTea.image} alt="Local Product" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.tea1Text.text}</p>
                    </div>
                    <div className="border bg-[#f2f2f2]">
                        <img src={imageCodes.localOil.image} alt="Local Product" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                        <p className="py-4 text-center">{textCodes.noodleText.text}</p>
                    </div>
                </div>
            </div>

            {/*              end of local product section                */}

            {/*                    packaging section               */}
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-10 pt-10">
                <div className="text-center px-4 lg:px-20 xl:px-20">
                    <h1 className="text-xl lg:text-2xl xl:text-2xl lg:pt-20 xl:pt-20">{titleCodes.packaging.title}</h1>
                    <p className="pt-4 leading-loose text-justify">{textCodes.packText.text}</p>
                </div>
                <div>
                    <img src={imageCodes.packaging.image} alt="packaging" width={560} height={240} />
                </div>
            </div>
            {/*              end of packaging section                */}


            {/*              delivery section                */}
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-0 pt-10">
                <div className="lg:pl-20 xl:pl-20">
                    <img src={imageCodes.delivery.image} alt="delivery" width={560} height={240} />
                </div>
                <div className="text-center px-4 lg:px-20 xl:px-20">
                    <h1 className="text-xl lg:text-2xl xl:text-2xl lg:pt-20 xl:pt-20 pt-10">{titleCodes.delivery.title}</h1>
                    <p className="pt-4 leading-loose text-justify">{textCodes.deliText.text}</p>
                </div>
            </div>
            {/*              end of delivery section                */}

        </div >
    );
}

export default Home;